import {useAppState} from "@/store";

export default function TimeChoice({startTime}) {

    const {state, setState} = useAppState()


    const setChosenTime = () => {
        setState(s => {
            s.chosen_time = startTime
        })
    }

    const selected = startTime.time === state.chosen_time?.time

    return (
        <div
            className={"w-full whitespace-nowrap rounded-lg border-2 flex flex-col items-center justify-center p-[16px] cursor-pointer transition-colors " + (selected ? 'bg-brand-orange text-white border-brand-orange' : 'border-inactive-grey hover:bg-brand-orange/50 hover:border-brand-orange')}
            onClick={setChosenTime}
        >
            {/*{to12HrTime(time)}*/}
            {startTime.time}
        </div>
    )
}
